module.exports = __webpack_public_path__ + "static/media/005.d1ab2bd2.jpg";